export const CUSTOMIZE_PORTAL = 'CUSTOMIZE_PORTAL';
export const CUSTOMIZE_PORTAL_ERROR = 'CUSTOMIZE_PORTAL_ERROR';
export const CUSTOMIZE_META = 'CUSTOMIZE_META';
export const CUSTOMIZE_META_ERROR = 'CUSTOMIZE_META_ERROR';
export const CUSTOMIZE_LOGIN = 'CUSTOMIZE_LOGIN';
export const CUSTOMIZE_LOGIN_ERROR = 'CUSTOMIZE_LOGIN_ERROR';
export const CUSTOMIZE_REGISTER = 'CUSTOMIZE_REGISTER';
export const CUSTOMIZE_REGISTER_ERROR = 'CUSTOMIZE_REGISTER_ERROR';
export const CUSTOMIZE_HEADER = 'CUSTOMIZE_HEADER';
export const CUSTOMIZE_HEADER_ERROR = 'CUSTOMIZE_HEADER_ERROR';
export const CUSTOMIZE_SIDEBAR_MENU = 'CUSTOMIZE_SIDEBAR_MENU';
export const CUSTOMIZE_SIDEBAR_MENU_ERROR = 'CUSTOMIZE_SIDEBAR_MENU_ERROR';
export const SET_DASHBOARD_HEADSCRIPT = 'SET_DASHBOARD_HEADSCRIPT';
export const SET_DASHBOARD_HEADSCRIPT_ERROR = 'SET_DASHBOARD_HEADSCRIPT_ERROR';
export const SET_DASHBOARD_BODYSCRIPT = 'SET_DASHBOARD_HEAD_SCRIPT';
export const SET_DASHBOARD_BODYSCRIPT_ERROR = 'SET_DASHBOARD_HEADSCRIPT_ERROR';
export const SET_LOGIN_HEADSCRIPT = 'SET_LOGIN_HEADSCRIPT';
export const SET_LOGIN_HEADSCRIPT_ERROR = 'SET_LOGIN_HEADSCRIPT_ERROR';
export const SET_LOGIN_BODYSCRIPT = 'SET_LOGIN_BODYSCRIPT';
export const SET_LOGIN_BODYSCRIPT_ERROR = 'SET_LOGIN_BODYSCRIPT_ERROR';
export const SET_REGISTER_HEADSCRIPT = 'SET_REGISTER_HEADSCRIPT';
export const SET_REGISTER_HEADSCRIPT_ERROR = 'SET_REGISTER_HEADSCRIPT_ERROR';
export const SET_REGISTER_BODYSCRIPT = 'SET_REGISTER_BODYSCRIPT';
export const SET_REGISTER_BODYSCRIPT_ERROR = 'SET_REGISTER_BODYSCRIPT_ERROR';
